import { EventHandler, SyntheticEvent } from "react";

export const useStopBubbling = <T extends SyntheticEvent>(
  handler: EventHandler<T> = () => {},
) => {
  return (e: T) => {
    e.stopPropagation();
    handler(e);
  };
};
